const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const padLeft = require('lodash/string/padLeft');

// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const HoldersData = require('./HoldersData');

// @constants
const { DOCUMENT_TYPE_NIF, DOCUMENT_TYPE_NIF_LENGTH } = require('constants/index');
const maxHolders = 4;

class HoldersDataList extends React.Component {
    constructor(props) {
        super(props);

        const { values } = this.props;
        this.state = {
            holdersDataList:
                values.length >= 1
                    ? values
                    : [
                          {
                              firstName: '',
                              lastName: '',
                              secondlastName: '',
                              identificationType: 'N',
                              identificationValue: '',
                              accountRelation: ''
                          }
                      ],
            count: values.length >= 1 ? values.length : 0
        };

        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleHoldersDataAdder = this.handleHoldersDataAdder.bind(this);
        this.onRemove = this.onRemove.bind(this);
    }

    componentWillMount() {
        this.props.dataReceiver(this.state.holdersDataList);
    }

    onBlur(event, formId, prop, isChange) {
        let holdersDataList = this.state.holdersDataList;
        const callDocumentBlur = event.target.name === 'identificationValue' && !isChange;
        callDocumentBlur && this.handleDocumentBlur(event);

        holdersDataList[formId][prop] = event.target.value;
        this.setState({holdersDataList});
        this.props.dataReceiver(holdersDataList);
    }

    onChange(event, formId, prop) {
        let holdersDataList = this.state.holdersDataList;
        holdersDataList[formId][prop] = event.value;
        this.props.dataReceiver(holdersDataList);
    }

    onRemove(formId) {
        let holdersDataList = this.state.holdersDataList;
        let count = this.state.count - 1;
        holdersDataList = holdersDataList.filter(function(item, i) {
            item;
            return i != formId;
        });

        this.setState({
            holdersDataList: holdersDataList,
            count: count
        });

        this.props.dataReceiver(holdersDataList);
    }

    handleDocumentBlur(event){
        const index = event.target.id.replace('inp_identificationvalue_','');
        const documentType = this.state.holdersDataList[index].identificationType;
        let value = event.target.value;
        if (documentType === DOCUMENT_TYPE_NIF && value !== '' && value.length < DOCUMENT_TYPE_NIF_LENGTH) {
            value = padLeft(value, DOCUMENT_TYPE_NIF_LENGTH, '0');
        }
        event.target.value = value.toUpperCase();
    }

    handleHoldersDataAdder() {
        let holdersDataList = this.state.holdersDataList;
        let count = this.state.count + 1;
        holdersDataList.push({
            firstName: '',
            lastName: '',
            secondlastName: '',
            identificationType: 'N',
            identificationValue: '',
            accountRelation: ''
        });
        this.setState({
            holdersDataList: holdersDataList,
            count: count
        });
        this.props.dataReceiver(holdersDataList);
    }

    render() {
        const { errorsState } = this.props;
        const errors = errorsState[1];
        let holdersDataForms = [];
        let classAddTax =
            this.state.holdersDataList.length <= maxHolders - 1 ? 'add-holders' : 'hidden';
        let showRemove =
            this.state.holdersDataList.length > 1 &&
            this.state.holdersDataList.length <= maxHolders;

        if (this.state.holdersDataList.length >= 1) {
            this.state.holdersDataList.forEach((taxationForm, index) => {
                holdersDataForms.push(
                    <HoldersData
                        key={index}
                        relationTypeSource={this.props.relationTypeSource}
                        identificationTypeSource={this.props.identificationTypeSource}
                        handleChange={this.onChange}
                        handleBlur={this.onBlur}
                        handleRemove={this.onRemove}
                        showRemove={showRemove}
                        formData={this.state.holdersDataList[index]}
                        formId={index}
                        regexInputFullName={this.props.regexInputFullName}
                        errorsState={
                            errors && errors[index]
                                ? errors[index]
                                : {
                                      firstName: false,
                                      lastName: false,
                                      secondlastName: false,
                                      identificationType: false,
                                      identificationValue: false,
                                      accountRelation: false
                                  }
                        }
                    />
                );
            });
        }
        return (
            <div className="holders-form">
                {holdersDataForms}
                <div className={classAddTax}>
                    <OKButton
                        leftIcon="icon icon-agregar"
                        modifier="ghost"
                        onClick={this.handleHoldersDataAdder}
                    >
                        <FormattedText
                            value="contractsView-checkingAccountHoldersAdd"
                        />
                    </OKButton>
                </div>
            </div>
        );
    }
}

HoldersDataList.propTypes = {
    dataReceiver: PropTypes.func,
    taxCountryOptions: PropTypes.array,
    relationTypeSource: PropTypes.array,
    identificationTypeSource: PropTypes.array,
    values: PropTypes.any.isRequired,
    errorsState: PropTypes.any.isRequired,
    regexInputFullName: PropTypes.any
};

module.exports = HoldersDataList;
